import { ElementType, ReactNode, forwardRef } from "react";
// hooks
import { TButtonRound, TButtonSize, TVariant } from "@/utils/types/design";
// components
import LoaderSpinner from "../LoadSpinner/LoadSpinner";
import { ClassValue } from "clsx";
import { clsx } from "clsx";
import { variants, roundedness, sizes } from "./types";

interface IButton {
	onClick?: (e: MouseEvent) => void;
	onMouseDown?: (e: MouseEvent) => void;
	onMouseUp?: (e: MouseEvent) => void;
	children: ReactNode;
	className?: ClassValue;
	classNameButton?: ClassValue;
	variant?: TVariant;
	type?: "button" | "submit";
	disabled?: boolean;
	isLoading?: boolean;
	size?: TButtonSize;
	rounded?: TButtonRound;
	as?: ElementType;
}

const Button = forwardRef<HTMLElement, IButton>(
	(
		{
			onClick,
			onMouseDown,
			onMouseUp,
			type = "button",
			variant = "primary",
			size = "md",
			rounded = "rounded",
			disabled,
			isLoading,
			className,
			classNameButton,
			as = "button",
			children,
		},
		ref
	) => {
		const Comp = as;

		const attrs = {};

		if (as === "button") {
			// @ts-ignore
			attrs.type = type;
		}
		return (
			<span
				className={clsx(
					"inline-flex select-none h-full",
					variants[variant].span,
					roundedness[rounded],
					className
				)}
				ref={ref}>
				<Comp
					{...attrs}
					className={clsx(
						"flex w-full",
						variants[variant].button,
						sizes[size],
						roundedness[rounded],
						classNameButton
					)}
					onClick={onClick}
					onMouseDown={onMouseDown}
					onMouseUp={onMouseUp}
					disabled={disabled || isLoading || false}>
					{isLoading ? (
						<div className="flex justify-center items-center">
							<LoaderSpinner className="w-5 h-5 text-white" />
						</div>
					) : (
						children
					)}
				</Comp>
			</span>
		);
	}
);

export default Button;
